import { KeyOf } from '~/types';

export const point = {
  point_bg_1: '#84DACF',
  point_bg_2: '#B5CF91',
  point_bg_3: '#A5CBED',
  point_bg_4: '#C4ABEC',
  point_bg_5: '#DFCD8F',
  point_bg_6: '#EEC2A9',
  point_bg_7: '#F59B9B',
  point_bg_8: '#FDABE7',
} as const;

export type Point = typeof point;
export type PointKeys = KeyOf<typeof point>;
